module.exports = __webpack_public_path__ + "static/elevated-logo-01-938e569adc167f26aaccc5d8b5bce89d.png";